<template>
	<div>
		<div id="tabs" class="container">
  
		    <div class="tabs">
		        <a v-for="(list, index) in prop_owners" :key="index" v-on:click="activetab=index" v-bind:class="[ activetab == index ? 'active' : '' ]">Partner Details - {{index+1}}</a>
           		 <a v-on:click="activetab=prop_owners.length" v-bind:class="[ activetab === prop_owners.length ? 'active' : '' ]">Other Details (LLP)</a>
		    </div>

		    <div class="content">
		        <div v-for="(list, index) in prop_owners" :key="index">
                <div v-if="activetab ==index" class="tabcontent">
		            <div class="col-md-12 p-l-r-0 f-left">
						<div class="form-group col-md-6  f-left">
							<p class="qustion_label">Name (in full)</p>
	            			<p class="ans_label">{{list.name}}</p>
		                </div>
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Mobile Number</p>
	            			<p class="ans_label">{{list.mobile_no}}</p>
		                </div>
		            </div>
		            <div class="col-md-12 p-l-r-0 f-left">
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Email ID</p>
	            			<p class="ans_label">{{list.email_id}}</p>
		                </div>
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Date of Birth</p>
	            			<p class="ans_label">{{list.dbo | FormatDate('DD-MM-YYYY')}}</p>
		                </div>
		            </div>
		            <div class="col-md-12 p-l-r-0 f-left">
		            	<div class="form-group col-md-6  f-left">
							<p class="qustion_label">Capital Contribution (INR)</p>
	            			<p class="ans_label">{{list.capital_contribution}}</p>
		                </div>
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Profit Sharing Ratio (%)</p>
	            			<p class="ans_label">{{list.profit_sharing_ratio}}%</p>
		                </div>
		            </div>
		            <div class="col-md-12 p-l-r-0 f-left">
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">PAN Number</p>
	            			<p class="ans_label">{{list.pan_number}}</p>
		                </div>
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Address</p>
	            			<p class="ans_label">{{list.address}}</p>
		                </div>
		            </div>
					<div class="col-md-12 p-l-r-0 f-left">
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">PAN (Self-Attested)</p>
	            			<p class="ans_label">PAN.pdf <span><a :href="list.pan_url"><img src="../assets/download_icon.png" style="width: auto;"></a></span></p>
		                </div>
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Aadhar (Self-Attested)</p>
	            			<p class="ans_label">Aadhar.pdf <span><a :href="list.aadhar_url"><img src="../assets/download_icon.png" style="width: auto;auto;"></a></span></p>
		                </div>
					</div>
					<div class="col-md-12 p-l-r-0 f-left">
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Passport size photo</p>
	            			<p class="ans_label">Passport.pdf <span><a :href="list.passport_size_photo"><img src="../assets/download_icon.png" style="width: auto;"></a></span></p>
		                </div>
					</div>
					<!-- <div class="col-md-12 p-l-r-0 f-left border-seperator"></div> -->

				</div>
		        </div>
		        <div v-if="activetab ==prop_owners.length" class="tabcontent">
		        	<div class="col-md-12 p-l-r-0 f-left">
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Website (if available)</p>
	            			<p class="ans_label">{{prop_others.website}}</p>
	            			
		                </div>
		            </div>
		            <div class="col-md-12 p-l-r-0 f-left">
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Name of the Partnership</p>
	            			<p class="ans_label">{{prop_others.name}}</p>
		                </div>
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Brand name (if any)</p>
	            			<p class="ans_label">{{prop_others.brand}}</p>
		                </div>
		            </div>

					<div class="col-md-12 p-l-r-0 f-left">
		                <div class="form-group col-md-12  f-left">
							<p class="qustion_label">Any specific points to be included in the partnership deed</p>
	            			<p class="ans_label">{{prop_others.partnership_deed}}</p>
		                </div>
		            </div>
					<div class="col-md-12 p-l-r-0 f-left">
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Registered office of the proposed business</p>
	            			<p class="ans_label">{{prop_others.registered_office}}</p>
		                </div>
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">{{prop_others.registered_office}}</p>
	            			<p class="ans_label">Agreement.pdf <span><a :href="prop_others.registered_office_doc_url" target="_blank"><img src="../assets/download_icon.png" style="width: auto;"></a></span></p>
		                </div>
					</div>
					<div class="col-md-12 p-l-r-0 f-left">
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Any Utility Bill</p>
	            			<p class="ans_label">Utility.pdf <span><a :href="prop_others.any_utility_bill_url" target="_blank"><img src="../assets/download_icon.png" style="width: auto;auto;"></a></span></p>
		                </div>
					</div>
					<div class="col-md-12 p-l-r-0 f-left">
		                <div class="form-group col-md-12  f-left">
							<p class="qustion_label">NOC if rented premise or property tax receipt (if business premise self owned)</p>
	            			<p class="ans_label">receipt.pdf <span><a :href="prop_others.noc" target="_blank"><img src="../assets/download_icon.png" style="width: auto;"></a></span></p>
		                </div>
					</div>
		        </div>
		    </div>
		  
		</div>
	</div>
</template>

<script>
export default {
    name:'partnership_form_preview',
	props: ['prop_owners', 'prop_others'],
     watch:{
       
    },
    data() {
        return {
        	activetab: '1'
        }
    },
    methods: {

    }
};

</script>